export const SET_SHUFFLED_ORDER = "SET_SHUFFLED_ORDER";
export const ENSURE_SHUFFLED_ORDER = "ENSURE_SHUFFLED_ORDER";

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const setShuffledOrder = (order) => ({
  type: SET_SHUFFLED_ORDER,
  payload: order,
});

// Thunk: only shuffles if there's no existing order yet,
// or merges in new product IDs if some appeared since last shuffle
export const ensureShuffledOrder = (productIds) => (dispatch, getState) => {
  const { shuffledOrder } = getState().shuffle;

  if (!shuffledOrder) {
    dispatch(setShuffledOrder(shuffleArray(productIds)));
    return;
  }

  const existing = new Set(shuffledOrder);
  const newIds = productIds.filter((id) => !existing.has(id));

  if (newIds.length) {
    dispatch(setShuffledOrder([...shuffledOrder, ...shuffleArray(newIds)]));
  }
};
